import { useState } from "react";

/**
 * LIGHT OR DARK, THE VISITOR'S CHOICE. theme-tokens.css already honours
 * `data-theme` on <html> over the system's answer; this writes it and
 * remembers it on the visitor's phone. Nobody's choice yet: the system's.
 */
const KEY = "cuotas-public-theme";
type Theme = "light" | "dark";

function storedTheme(): Theme | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}

function systemTheme(): Theme {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** Before the first paint (main.tsx): a stored choice, applied, so the page never flashes the other one. */
export function applyStoredTheme(): void {
  const stored = storedTheme();
  if (stored !== null) document.documentElement.dataset["theme"] = stored;
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => storedTheme() ?? systemTheme());
  const next: Theme = theme === "dark" ? "light" : "dark";

  const toggle = (): void => {
    document.documentElement.dataset["theme"] = next;
    try {
      window.localStorage.setItem(KEY, next);
    } catch {
      // A private window: the choice lasts this visit only.
    }
    setTheme(next);
  };

  return (
    <button
      type="button"
      className="share-theme"
      aria-label={next === "dark" ? "Cambiar a modo oscuro" : "Cambiar a modo claro"}
      title={next === "dark" ? "Modo oscuro" : "Modo claro"}
      onClick={toggle}
    >
      {theme === "dark" ? <SunMark /> : <MoonMark />}
    </button>
  );
}

function MoonMark() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path
        d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SunMark() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
      <path
        d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
